import { useEffect, useRef } from "react";

import { useDispatchSidePanels } from "contexts/sidePanels";

import { registerCorePanels } from "./registerPanels";

/**
 * Hook to register core panels on mount.
 * Should be called once at the app level.
 */
export function usePanelRegistration() {
    const dispatch = useDispatchSidePanels();
    const hasRegistered = useRef(false);

    useEffect(() => {
        if (!hasRegistered.current) {
            registerCorePanels(dispatch);
            hasRegistered.current = true;
        }
    }, [dispatch]);
}
